export default "__VITE_ASSET__CqJl1aDI__"